module.exports = __webpack_public_path__ + "img/pauli-y-root-10.b6e7746b.svg";